var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiagramProject = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C2.17157 3 1.5 3.67157 1.5 4.5V9C1.5 9.82843 2.17157 10.5 3 10.5H7.5C8.32843 10.5 9 9.82843 9 9V4.5C9 3.67157 8.32843 3 7.5 3H3ZM3.75 4.5C3.33579 4.5 3 4.83579 3 5.25V8.25C3 8.66421 3.33579 9 3.75 9H6.75C7.16421 9 7.5 8.66421 7.5 8.25V5.25C7.5 4.83579 7.16421 4.5 6.75 4.5H3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3C15.6716 3 15 3.67157 15 4.5V9C15 9.82843 15.6716 10.5 16.5 10.5H21C21.8284 10.5 22.5 9.82843 22.5 9V4.5C22.5 3.67157 21.8284 3 21 3H16.5ZM17.25 4.5C16.8358 4.5 16.5 4.83579 16.5 5.25V8.25C16.5 8.66421 16.8358 9 17.25 9H20.25C20.6642 9 21 8.66421 21 8.25V5.25C21 4.83579 20.6642 4.5 20.25 4.5H17.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C11.1716 12 10.5 12.6716 10.5 13.5V18C10.5 18.8284 11.1716 19.5 12 19.5H16.5C17.3284 19.5 18 18.8284 18 18V13.5C18 12.6716 17.3284 12 16.5 12H12ZM12.75 13.5C12.3358 13.5 12 13.8358 12 14.25V17.25C12 17.6642 12.3358 18 12.75 18H15.75C16.1642 18 16.5 17.6642 16.5 17.25V14.25C16.5 13.8358 16.1642 13.5 15.75 13.5H12.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H15V7.5H9V6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56066 9L12.2951 12.7345L11.2345 13.7951L7.5 10.0607L8.56066 9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiagramProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diagram-project.f4dc89c7ccae1e8f207dd9da4afd7ea6.svg";